import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate  , Link } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import InputEmoji from "react-input-emoji";
import { Markup } from 'interweave';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MicRecorder from 'mic-recorder-to-mp3';
import { Player } from 'react-simple-player';
import Badge from 'react-bootstrap/Badge';

import './Header.css'
import classes from './Header.module.css';
import MessangerButton from '../Global/MessangerButton';
import Loader from '../Global/Loader';

import noThumb from "../../images/no-thumb.jpg";
const noAvatar = "https://hostpapasupport.com/knowledgebase/wp-content/uploads/2018/04/1-13.png";

const recorder = new MicRecorder({bitRate: 128});

function secToTime(sec) {
  var date = new Date(0);
  date.setSeconds(sec); // specify value for SECONDS here
  var timeString = date.toISOString().substring(11, 19);
  return timeString;
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState([window.innerHeight, window.innerWidth]);

  useEffect(() => {
    function handleResize() {
      setWindowSize([window.innerHeight, window.innerWidth]);
    }
    window.addEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function Header() {
  const navigate = useNavigate();
  const { key } = useParams();
  const {register, handleSubmit} = useForm();
  const [inputValue, setInputValue] = useState(key);
  const [height, width] = useWindowSize(0);
  const [theme, setTheme] = useState('');
  // const [modeSwitch, setModeSwitch] = useState(true);
  // dropdown menu right
  const [isOpen, setIsOpen] = useState(true);
  // const [navbar, setNavbar] = useState(false);
  // const [checked, setChecked] = useState();
  const [notifs, setNotifs] = useState([]);
  const [isLoading3, setIsLoading3] = useState(false);
  const [count, setCount]= useState(0);
  const [unreadMessage, setUnreadMessage] = useState(0);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [isLoading1, setIsLoading1] = useState(false);
  const [recentUsers, setRecentUsers] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);
  const [user, setUser] = useState([]);
  const [chats, setChats] = useState([]);
  const [text, setText] = useState("");
  const [file, setFile] = useState([]);
  const [activeFile, setActiveFile] = useState(false);
  const [intervalId, setIntervalId] = useState(0);
  const [statusInterval, setStatusInterval] = useState(0);

  const [isRecording, setIsRecording] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [activeRecorder, setActiveRecorder] = useState(false);
  const [recordedFile, setRecordedFile] = useState([]);
  const [counter, setCounter] = useState(0);
  const [counterId, setCounterId] = useState(0);
  const [isSending, setIsSending] = useState(false);

  ReactSession.setStoreType("localStorage");
  const logged_user = ReactSession.get("logged_user");

  useEffect(()=> {
    const themeType = localStorage.getItem('theme') || 'light-theme';
    document.body.classList.add(themeType);
    setTheme(themeType);
  }, [])

  const readNotif = (id) => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifReadAll.php`, {
      id: id,
      action: 'READ_ONE'
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then(res => {
      // console.log(res.data);
    })
  }

  const notifsCount = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifsCount.php`, {
      user_id: logged_user,
      status: 0
    }, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    })
      .then(res => {
        // console.log(res.data);
        res.data.status === 'success' && setCount(res.data.count);
      }).catch(err => {
          console.log(err);
      })
  }

  useEffect(() => {
    notifsCount();
  }, [logged_user]);

  const readAll = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifReadAll.php`, {
        user_id: logged_user,
        action: 'READ_ALL'
    }, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    })
    .then(res => {
      if(res.data.status === 'success') {
        document.querySelectorAll(`.${classes.notif_unread}`).forEach(e => e.setAttribute('style', 'background-color: white !important'));
        notifsCount();
        getNotifications();
      }
    })
  }

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/conversation.php`, 
        {
            user_id: logged_user,
            action: 'GET_UNREAD_MSG'
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            // console.log(res.data);
            res.data.status === 'success' && setUnreadMessage(res.data.unread);
        }).catch(err => {
            console.log(err);
        })
  }, [logged_user]);

  const getNotifications = () => {
    const config = {
      params: {
          uid: logged_user,
          action: 'updateNotifs',
          limit: 10
      },
      headers: {
          "Content-Type": "multipart/form-data",
      }
    }

    axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifs.php?page=1`, null, config)
    .then(res => {
        // console.log(res.data);
        setNotifs(res.data);
        setIsLoading3(true);
    }).catch(err => {
        console.log(err);
    })
  }

  const toggleTheme = () => {
    const themeType = theme === 'light-theme' ? 'dark-theme' : 'light-theme';

    setTheme(themeType);
    localStorage.setItem('theme', themeType);

    if(themeType === 'dark-theme') {
      document.body.classList.remove('light-theme');
      document.body.classList.add('dark-theme');
    }else {
      document.body.classList.remove('dark-theme');
      document.body.classList.add('light-theme');
    }
  }

  const changeNavPosition = () => {
      if(window.scrollY > 80) {
        // setNavbar(true);
        document.body.classList.add('navbar-active');
      }else {
        // setNavbar(false);
        document.body.classList.remove('navbar-active');
      }
  }

  window.addEventListener('scroll', changeNavPosition);
    

  useEffect(() => {
    if (width < 768) {
      let aside = document.getElementsByTagName('aside')[0];
      aside && aside.classList.remove('active');

      document.getElementsByClassName('main-content')[0].classList.add('full-width');
    }
  }, [width, height]);

  const toggleSidebar = () => {
    let aside = document.getElementsByTagName('aside')[0];
    aside && aside.classList.toggle('active');

    document.getElementsByClassName('main-content')[0].classList.toggle('full-width');
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    toggleMenu(1);
  }

  const toggleNotif = () => {
    setIsOpen(!isOpen);
    toggleMenu(0);

    if(isOpen) {
      getNotifications();
    }else {
      setNotifs([]);
      setIsLoading3(false);
    }
  }

  useEffect(() => {
    
  }, [isOpen]);

  const toggleMenu = (n) => {
    const dropdown = document.getElementsByClassName('dropdown-menu')[n];
    if (isOpen) {
      dropdown && dropdown.classList.add('show');
    } else {
      dropdown && dropdown.classList.remove('show');
    }
  }

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  }

  const onSubmit = (data) => {
    if(inputValue) {
      let search = document.getElementsByClassName('search-wrapper')[0];
      search && search.classList.remove('active');
      
      navigate(`/search/${inputValue}`);
    }
  }
  
  const showOnlineUsers = () => {
    let app = document.getElementsByClassName('app_container')[0];
    app.style.display = app.style.display === 'block' ? 'none' : 'block';

    if(app.style.display === 'block') {
      getOnlineUsers();
      getRecentUsers();
    }else {
      setUser([]);
      setOnlineUsers([]);
      setRecentUsers([]);
      setIsLoading1(false);
      setIsLoading2(false);
    }
  }

  const loadMessage = (id) => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/messanger.php`, {
      user_id: logged_user,
      uid: id,
      action: 'getUserMessages'
    }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      // console.log(res.data);
      setUser({
        uid: res.data.uid,
        name: res.data.name,
        username: res.data.username,
        avatar: res.data.avatar
      })
      setChats(res.data.chats);

      ReactSession.set("msg_user", id);

      const newIntervalId = setInterval(() => {
        updateMessages();
      }, 3000);
      setIntervalId(newIntervalId);
    })
  }

  const updateMessages = () => {
    let uid = ReactSession.get("msg_user");

    axios.post(`${process.env.REACT_APP_API_URL}/api/user/messanger.php`, {
      user_id: logged_user,
      uid: uid,
      action: 'getUserMessages'
    }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      // console.log(res.data);
      setChats(res.data.chats);
    })
  }

  const showMessageArea = (id) => {
    loadMessage(id);
    
    document.getElementsByClassName('msg_area')[0].style.display = "block";
    document.getElementsByClassName('app_container')[0].style.display = 'none';
  }

  const toggleSearchBar = () => {
    let search = document.getElementsByClassName('search-wrapper')[0];
    search && search.classList.toggle('active');
  }

  const getOnlineUsers = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/messanger.php`, 
      {
        user_id: logged_user,
        action: 'getOnlineUsers'
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        setOnlineUsers(res.data);
        setIsLoading1(true);
      })
  }

  const getRecentUsers = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/messanger.php`, 
      {
        user_id: logged_user,
        action: 'getRecentUsers'
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        setRecentUsers(res.data);
        setIsLoading2(true);
      })
  }

  useEffect(() => {
    // getOnlineUsers();
    // getRecentUsers();
  }, [])

  const updateStatus = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/updateStatus.php`, {
      user_id: logged_user,
      action: 'updateStatus'
    }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      // console.log(res.data);
    })
  }

  useEffect(() => {
    if(logged_user) {
      const newStatusInterval = setInterval(() => {
        updateStatus();
      }, 10000);

      setStatusInterval(newStatusInterval);
    }else {
      if (statusInterval) {
        clearInterval(statusInterval);
      }
    }
  }, [logged_user]);

  const handleDelete = (id) => {
    const toast_id = toast.loading("Please wait...");
    // let chat = document.getElementById(`chat_${id}`);
    
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/messanger.php`, {
        user_id: logged_user,
        msg_id: id,
        action: 'deleteMessage'
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        // if(res.data.status === 'success') {
        //   if(chat) {
        //     chat.style.display = 'none';
        //   }
        // }
            
          updateMessages(user.uid);
          toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
      })
  }

  function handleOnEnter() {
    !isSending && sendMessage();
  }

  const sendMessage = () => {
    setIsSending(true);
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/messanger.php`, {
      user_id: logged_user,
      uid: user.uid,
      msg_body: text,
      file: file,
      action: 'sendMessage'
    }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      // console.log(res.data);
      setText('');
      updateMessages(user.uid);
      setIsSending(false);
    })
  }


  const closeMessageArea = () => {
    document.getElementsByClassName('msg_area')[0].style.display = "none";
    setUser([]);
    setChats([]);
    setText('');
    setFile([]);
    setActiveFile(false);
    setIsLoading1(false);
    setIsLoading2(false);
    
    deleteRecording();
    stopRecording();

    if (intervalId) {
      clearInterval(intervalId);
    }
  }

  const onImageChange = (e) => {
    setFile(e.target.files[0]);
    setActiveFile(true);

    if(!e.target.files[0]){
      setActiveFile(false);
    }
  }

  const startRecording = () => {
    setIsRecording(true);
    setActiveRecorder(true);
    const id = setInterval(() => setCounter((oldCount) => oldCount + 1), 1000);

    setCounterId(id);

    recorder.start().then(() => {
        // button.textContent = 'Stop recording';
        // button.classList.toggle('btn-danger');
        // button.removeEventListener('click', startRecording);
        // button.addEventListener('click', stopRecording);
        // console.log("recording...");
      }).catch((e) => {
        console.error(e);
      });
}

  const stopCounter = () => {
      if (counterId) {
          clearInterval(counterId);
      }

      setCounter(0);
  }

  const stopRecording = () => {
      setActiveRecorder(false);
      stopCounter();

      recorder.stop().getMp3().then(([buffer, blob]) => {
          // console.log(buffer, blob);
          const file = new File(buffer, 'music.mp3', {
              type: blob.type,
              lastModified: Date.now()
          });

          setFile(file);
          // console.log(file);

          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
              setRecordedFile(reader.result);
          };
          reader.onerror = function (error) {
              console.log('Error: ', error);
          };
      }).catch((e) => {
          // console.error(e);
          console.log("err");
      });
  }

  const deleteRecording = () => {
      setIsRecording(false);
      setRecordedFile([]);
      setFile(false);
      stopCounter();
  }

  useEffect(() => {
      // console.log(recordedFile);
      // console.log(recordedFile.length !== 0 ? 'hi' : 'hello');
  }, [recordedFile])

  const sendVoiceNote = () => {
    setIsSending(true);
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/messanger.php`, {
        user_id: logged_user,
        uid: user.uid,
        msg_body: '',
        file: file,
        action: 'sendMessage'
    }, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then(res => {
        // console.log(res.data);
        setText('');
        updateMessages(user.uid);
        deleteRecording();
        setIsSending(false);
    }).catch(err => {
        console.log(err);
    })
  }

  const controller = () => {
    const audio = document.getElementById('playaudio');
    isPlaying ? audio.pause() : audio.play();

    audio.onended = () => {
      setIsPlaying(false);
    }

    setIsPlaying(!isPlaying);
  }

  return (
    <header>
      <div className="app-header">
        <div className="app-header-left">
          <div className="toggleBtn" onClick={() => toggleSidebar()}>
            <span className="app-icon"></span>
          </div>
          <div className="app-logo">
            <Link to="/"><img src={`${process.env.REACT_APP_API_URL}/storage/uploads/wesharez-pl-png5e9ace7d1bbda.png`} alt="" /></Link>
          </div>
          {/* <p className="app-name">Portfolio</p> */}
          <div className="search-wrapper">
            <form onSubmit={handleSubmit(onSubmit)}>
              <input className="search-input form-control" {...register('search')} defaultValue={inputValue} onChange={handleChange} onKeyDown={handleKeyDown} type="text" placeholder="Search" />
              <button type="submit">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="feather feather-search" viewBox="0 0 24 24">
                  <defs></defs>
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="M21 21l-4.35-4.35"></path>
                </svg>
              </button>
            </form>
          </div>
        </div>
        <div className="app-header-right">
          
          {/* <button className='mode-switch'>
            <label>
              <input className='toggle-checkbox' type='checkbox' defaultChecked={checked} onChange={handleClick} />
              <div className='toggle-slot'>
                <div className='sun-icon-wrapper'>
                  <svg aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" className="iconify sun-icon" data-icon="feather-sun" data-inline="false"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><circle cx="12" cy="12" r="5"></circle><path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"></path></g></svg>
                </div>
                <div className='toggle-button'></div>
                <div className='moon-icon-wrapper'>
                  <svg aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" className="iconify sun-icon" data-icon="feather-sun" data-inline="false"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><circle cx="12" cy="12" r="5"></circle><path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"></path></g></svg>
                </div>
              </div>
            </label>
          </button> */}
          <button className="search_btn icon_btn" title="Add New Project" onClick={() => toggleSearchBar()}>
            <svg viewBox="0 0 24 24" width="24" height="24">
              <g data-name="Layer 2">
                <g data-name="search">
                  <rect width="24" height="24" opacity="0"/>
                  <path d="M20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z"/>
                </g>
              </g>
            </svg>
          </button>
          <div className="width_lg">
            {
              logged_user && <Link to="/share">
                <button className="add-btn icon_btn" title="Add New Project">
                  <svg className="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
              </Link>
            }
          </div>
          {
            logged_user && <div className='notification'><button onClick={() => toggleNotif()} className="notification-btn icon_btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                {
                  count > 0 && <div className={classes.notif_badge}>{count}</div>
                }
            </button>
            <div id="notification-ui_dd" className="dropdown-menu notification-ui_dd" aria-labelledby="navbarDropdown">
                <div className="notification-ui_dd-header">
                  <h3 className="text-center">Notifications</h3>
                </div>
                <div className="notification-ui_dd-content">
                  {
                    isLoading3 ? <>
                      {
                        notifs && notifs.map ? notifs.map((notif, index) => {
                          return (
                            notif.name && notif.msg && notif.url && notif.name && <Link onClick={() => readNotif(notif.id)} to={notif.url} className={`notification-list  text-dark ${notif.status === '0' ? classes.notif_unread : ''}`} key={index}>
                              <div className="notification-list_img">
                                <img src={notif.avatar} onError={e => {e.target.src = noThumb}} alt={notif.name} />
                              </div>
                              <div className="notification-list_detail">
                                <p><b><Markup content={notif.name} /></b>
                                <br />
                                <span className="text-muted"><Markup content={notif.msg} /></span></p>
                              </div>
                              <p><small>{notif.added_on}</small></p>
                            </Link>
                          )
                        })
                        : <div className='empty_notifs'>
                            <div className="icon"><i className="fa-solid fa-bell"></i></div>
                            <h4>No notifications yet</h4>
                            <p>Stay tuned! Notifications about your activity will show up here.</p>
                          </div>
                      }
                    </>
                    : <li className="no_user_found mt-4">
                        <Loader />
                      </li>
                  }
                </div>
                <div className="notification-ui_dd-footer">
                  <Link to={false} onClick={() => readAll()}>Mark all as read</Link>
                  <Link to="/dashboard/notifications" className="">View All</Link>
                </div>
              </div>
          </div>
          }
          <div className="width_lg">
            {
              logged_user && <Link to="/dashboard/messages"><button className="messages-btn icon_btn">
                  <svg viewBox="0 0 64 64" width="26" height="26">
                    <path d="M52 13H12a6 6 0 0 0-6 6v27a6 6 0 0 0 6 6h40a6 6 0 0 0 6-6V19a6 6 0 0 0-6-6Zm2 33a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V19a2 2 0 0 1 2-2h40a2 2 0 0 1 2 2Z"/>
                    <path d="M47.91 19.32 32 29.62l-15.91-10.3a2 2 0 0 0-2.18 3.36l17 11a2 2 0 0 0 2.18 0l17-11a2 2 0 1 0-2.18-3.36Z"/>
                  </svg>
                  {
                    unreadMessage > 0 && <div className={classes.notif_badge}>{unreadMessage}</div>
                  }
                </button>
              </Link>
            }
            {/* {
              logged_user && <Link to="/cart"><button className="cart-btn icon_btn">
                <svg  viewBox="0 0 256 256" width="24" height="24">
                  <rect width="256" height="256" fill="none"/>
                  <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" d="M184,184H69.81818L41.92162,30.56892A8,8,0,0,0,34.05066,24H16"/>
                  <circle cx="80" cy="204" r="20" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
                  <circle cx="184" cy="204" r="20" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
                  <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" d="M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48"/>
                </svg>
              </button>
            </Link>
            } */}
          </div>
          {
            !logged_user && <div className='user_quick'>
              <Link className="" to="/login">Login</Link>
              <Link className="" to="/register">Register</Link>
            </div>
          }
          {
            logged_user && <button className="profile-btn">
            <div onClick={() => toggleDropdown()} className="" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {/* <img className="d-inline img-fluid rounded-circle" src="https://bestigcaptions.com/wp-content/uploads/2022/02/Sad-Profile-Whatsapp-DP.jpg" alt="" /> */}
              <img className="d-inline img-fluid rounded-circle" src={ReactSession.get('avatar')} onError={e => {e.target.src = noAvatar}} alt={ReactSession.get('name')} />
            </div>
            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <Link className="dropdown-item" to={`/profile/${logged_user}/${ReactSession.get('name').toLowerCase().replace(/[^A-Z0-9]+/ig, "-")}`}><i className="fa-solid fa-user"></i> <Markup content={ReactSession.get('name')}></Markup></Link>
              <Link className="dropdown-item" to="/dashboard"><i className="fas fa-fw fa-user-circle"></i> Dashboard</Link>
              <div className="dropdown-divider"></div>
              <div className="width_sm">
                <Link className="dropdown-item" to="/share"><i className="fa-solid fa-upload"></i> Upload</Link>
                <Link className="dropdown-item" to="/dashboard/messages"><i className="fa-solid fa-envelope"></i> Inbox {unreadMessage > 0 && <Badge pill bg="danger">{unreadMessage}</Badge>}</Link>
                {/* <Link className="dropdown-item" to="/cart"><i className="fa-solid fa-cart-shopping"></i> Shopping Cart</Link> */}
                <div className="dropdown-divider"></div>
              </div>
              <Link className="dropdown-item" to="/dashboard/settings"><i className="fas fa-fw fa-cog"></i> Settings</Link>
              <Link className="dropdown-item" to="/logout" data-toggle="modal" data-target="#logoutModal"><i className="fas fa-fw fa-sign-out-alt"></i> Logout</Link>
            </div>
          </button>
          }
        </div>
      </div>
      <div className="container-fluid">
        <div className="container">
          <div className="left">
            <div className="navbar-container">
              <h6 className='m-0'>Go to:</h6>
              <div className="icons">
                <Link to="/activity/history" title='History'><i className="fa-regular fa-clock"></i></Link>
                <Link to="/activity/likedvideos" title="Liked Videos"><i className="fa-regular fa-heart"></i></Link>
                <Link to="/activity/watchlater" title="Watch Later"><i className="fa-regular fa-circle-play"></i></Link>
              </div>
            </div>
          </div>
          <div className="right">
            <button className="mode-switch" title="Switch Theme" onClick={toggleTheme}>
              {/* <svg className="moon" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" width="24" height="24" viewBox="0 0 24 24">
                <defs></defs>
                <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"></path>
              </svg> */}
              <img src="https://azyrusthemes.com/CircleVideoLight/images/icon_bulb_light.png" alt="bulb light" />
              {/* <img src="https://azyrusthemes.com/CircleVideoLight/images/icon_bulb_dark.png" alt="bulb dark" /> */}
            </button>
          </div>
        </div>
      </div>
      <MessangerButton />
      <div className="new_msg" onClick={() => showOnlineUsers()}>
        <div>
            <img width="20px" height="20px" src="https://static.thenounproject.com/png/641795-200.png" alt="" />
        </div>
      </div>
      <div className="app_container" style={{display: 'none'}}>
        <div className="contacts">
          <div className='online_users'>
            <div className="app_message_list">
              <h4 className="app_heading">Online Users</h4>
              <ul className="lists_group">
                {
                  isLoading1 ? <>
                    {
                      onlineUsers.length > 0 ? <>
                        {
                          onlineUsers && onlineUsers.map && onlineUsers.map((user, index) => {
                            return (
                              <li className="group_item" key={index} onClick={() => showMessageArea(user.id)}>
                                <Link data-id={user.id} className="item_content" to={false}>
                                  <div className="media">
                                    <div className="media_left">
                                      <div className="avatar avatar-img">
                                        <span className="status online"></span>
                                        <img className="img-responsive" src={user.avatar} alt='' />
                                      </div>
                                    </div>
                                    <div className="media_body">
                                      <h4><Markup content={user.name}></Markup> {user.unread > 0 && <Badge pill bg="danger">{user.unread}</Badge>}</h4>
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )
                          })
                        }
                      </>
                      : <li className="no_user_found text-muted mt-4">No user found!</li>
                    }
                  </>
                  : <li className="no_user_found mt-4">
                      <Loader />
                    </li>
                }
              </ul>
            </div>
          </div>
          <div className='recent_users'>
            <div className="app_message_list">
              <h4 className="app_heading">Recent</h4>
              <ul className="recent_activity">
                {
                  isLoading2 ? <>
                    {
                      recentUsers.length > 0 ? <>
                        {
                          recentUsers && recentUsers.map && recentUsers.map((user, index) => {
                            return (
                              <li className="group_item" key={index} onClick={() => showMessageArea(user.id)}>
                                <Link data-id={user.id} className="item_content" to={false}>
                                  <div className="media">
                                    <div className="media_left">
                                      <div className="avatar avatar-img">
                                        <span className="status offline"></span>
                                        <img className="img-responsive" width="100%" src={user.avatar} onError={e => {e.target.src = noThumb}} alt={user.name} />
                                      </div>
                                    </div>
                                    <div className="media_body">
                                      <h4><Markup content={user.name}></Markup> {user.unread > 0 && <Badge pill bg="danger">{user.unread}</Badge>}</h4>
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )
                          })
                        }
                      </>
                      : <li className="no_user_found text-muted mt-4">No user found!</li>
                    }
                  </>
                  : <li className="no_user_found mt-4">
                      <Loader />
                    </li>
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      {
        <div className="msg_area" style={{display: 'none'}}>
          <div className="msg_sec_container">
            <div className="app">
              <div className="app_header" id="222">
                <div className="left">
                  <div className="media">
                    <div className="media_left">
                        <div className="avatar avatar-img">
                          <img className="img-responsive" width="100%" src={user.avatar} onError={e => {e.target.src = noThumb}} alt={user.name} />
                        </div>
                    </div>
                    <div className="media_body">
                      <Link to={`/profile/${user.uid}/${user.username}`}><Markup content={user.name}></Markup></Link>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <div className="close_btn" onClick={() => closeMessageArea()}>
                    <img width="16px" height="16px" src="https://cdn-icons-png.flaticon.com/512/61/61155.png" alt="" />
                  </div>
                </div>
              </div>
              <div className='app_body'>
                <div className="content">
                  <div id="168" className="chats-container">
                    {
                      chats && chats.map && chats.map((chat, index) => {
                        return(
                          <div className={`chat ${chat.position}`} id={`chat_${chat.id}`} key={index}>
                            <div className="chat_body">
                              <div className="chat_content">
                                <p className="tipS tooltip-scale" title={chat.at_time}><Markup content={chat.reply} /></p>
                              </div>
                              <div className="del_btn">
                                {
                                  chat.by_user === logged_user && <Link className="del-msg" to={false} onClick={() => handleDelete(chat.id)}>delete</Link>
                                }
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                    
                    {/* <div className="chat chat_right" id="83">
                      <div className="chat_body">
                        <div className="chat_content">
                          <p className="tipS tooltip-scale" data-toggle="tooltip" data-placement="left" title="7 months ago">Hi Taku mi son</p>
                        </div>
                        <div className="del_btn">
                          <Link className="del-msg" data-id="83" to={false}>delete</Link>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="app_footer">
              {
                !isRecording ? <form className="msg_form" method="post" encType="multipart/form-data" noValidate={true}>
                  {/* <div className="img_name"></div> */}
                  <div className='input_area'>
                  <div className={`${classes.file} ${activeFile ? classes.activeFile : ''}`}>
                      <label htmlFor='input-file'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M26.052 15.998c-.086 0-.17 0-.252.002.132-.658.2-1.33.2-2 0-5.514-4.486-10-10-10-5.51 0-10 4.442-10.006 9.898l.016.202C2.584 14.59 0 17.556 0 21c0 3.492 2.516 6.496 6 7h5a1 1 0 0 0 0-2l-4.854.01C3.822 25.668 2 23.466 2 21c0-2.456 1.844-4.57 4.292-4.92l.86-.124a1 1 0 0 0 .858-.99l-.016-1.064C8 9.544 11.59 6 16 6c4.412 0 8 3.588 8 8 0 .542-.054 1.088-.164 1.618l-.264 1.272c-.066.318.028.646.248.884.22.236.536.358.864.308.022-.002.648-.084 1.368-.084C28.23 17.998 30 19.792 30 22c0 2.206-1.794 4-4 4h-7c-2.8 0-2.99-1.678-3-2v-6.636l2.366 2.364a1 1 0 0 0 1.414-1.414l-4.024-4.022a1.002 1.002 0 0 0-.712-.292c-.016 0-.028-.008-.044-.008a.987.987 0 0 0-.724.318l-4.028 4.024a1 1 0 0 0 1.414 1.414L14 17.412V24c0 1.382 1.044 4 5 4h7c3.308 0 6-2.692 6-6s-2.668-6.002-5.948-6.002z"/></svg>
                      </label>
                      <input type="file" name="img" id="input-file" onChange={onImageChange} />
                  </div>
                    <InputEmoji
                      value={text}
                      onChange={setText}
                      cleanOnEnter
                      onEnter={handleOnEnter}
                      placeholder="Type a message"
                    />
                    <div className={classes.voiceRecorder} onClick={() => startRecording()}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Layer 2"><g data-name="mic"><path d="M12 15a4 4 0 0 0 4-4V6a4 4 0 0 0-8 0v5a4 4 0 0 0 4 4z"/><path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V20H8.89a.89.89 0 0 0-.89.89v.22a.89.89 0 0 0 .89.89h6.22a.89.89 0 0 0 .89-.89v-.22a.89.89 0 0 0-.89-.89H13v-2.08A7 7 0 0 0 19 11z"/></g></g></svg>
                    </div>
                    {/* <button id="sendChatt" className="message_input_btn btn btn-primary" type="button" onClick={() => sendMessage()}>SEND</button> */}
                  </div>
                </form>
                : <div className={classes.voiceNote}>
                  <div className={classes.left}>
                      <div className={classes.delete} onClick={() => deleteRecording()}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M2.556 7.338a1.5 1.5 0 0 0 1.5 1.5h.8v17.725A4.942 4.942 0 0 0 9.792 31.5h12.416a4.942 4.942 0 0 0 4.936-4.937V8.838h.8a1.5 1.5 0 0 0 0-3h-5.25V4.29c0-2.09-1.7-3.791-3.79-3.791h-5.808c-2.09 0-3.79 1.7-3.79 3.791v1.547h-5.25a1.5 1.5 0 0 0-1.5 1.5zm9.75-3.047c0-.437.354-.791.79-.791h5.808c.436 0 .79.354.79.791v1.547h-7.389V4.29zm-4.45 4.547h16.288v17.725a1.939 1.939 0 0 1-1.936 1.937H9.792a1.939 1.939 0 0 1-1.936-1.937V8.838z"/><path d="M12.272 25.737a1.5 1.5 0 0 0 1.5-1.5V13.101a1.5 1.5 0 0 0-3 0v11.136a1.5 1.5 0 0 0 1.5 1.5zm7.456 0a1.5 1.5 0 0 0 1.5-1.5V13.101a1.5 1.5 0 0 0-3 0v11.136a1.5 1.5 0 0 0 1.5 1.5z"/></svg>
                      </div>
                  </div>
                  <div className={classes.right}>
                      {
                          // !activeRecorder ? <div className={classes.player}><Player src={recordedFile} height={40} /></div> : 
                      }
                      {
                        !activeRecorder ? <audio id="playaudio" src={recordedFile}></audio> : secToTime(counter)
                      }
                      {
                        !activeRecorder && <div className={classes.audioController} onClick={() => controller()}>
                          {
                            isPlaying ? <i className="fa-solid fa-pause"></i> : <i className="fa-solid fa-play"></i>
                          }
                        </div>
                      }
                      {
                          activeRecorder ?  <div className={`${classes.stop} ${classes.active}`} onClick={() => stopRecording()} title="Stop">
                              <svg xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h48v48H0z"/><path d="M12 12h24v24H12z"/></svg>
                          </div>
                          : <div className={`${classes.voiceRecorder} ${classes.active}`} onClick={() => startRecording()}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Layer 2"><g data-name="mic"><path d="M12 15a4 4 0 0 0 4-4V6a4 4 0 0 0-8 0v5a4 4 0 0 0 4 4z"/><path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V20H8.89a.89.89 0 0 0-.89.89v.22a.89.89 0 0 0 .89.89h6.22a.89.89 0 0 0 .89-.89v-.22a.89.89 0 0 0-.89-.89H13v-2.08A7 7 0 0 0 19 11z"/></g></g></svg>
                          </div>
                      }
                      <button className={`${classes.send} ${!activeRecorder ? classes.active : ''}`} title="Send" onClick={() => sendVoiceNote()} disabled={activeRecorder || isSending}>
                        {
                          isSending ? <Loader /> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M223.44434,114.03906,54.5293,19.44727A16.00042,16.00042,0,0,0,31.64355,38.78906L60.64746,120H136a8,8,0,0,1,0,16H60.64746L31.64355,217.21094a16.0398,16.0398,0,0,0,15.041,21.4082,16.039,16.039,0,0,0,7.8457-2.06641l168.91309-94.59179a16.00165,16.00165,0,0,0,.001-27.92188Z"/></svg>
                        }
                      </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </header>
  )
}

export default Header